// extracted by mini-css-extract-plugin
export var backDropFilter = "nav-footer-module--backDropFilter--3bc54";
export var container = "nav-footer-module--container--65c85";
export var footerMenuItem = "nav-footer-module--footerMenuItem--24071";
export var snsContainer = "nav-footer-module--snsContainer--42a86";
export var snsIcon = "nav-footer-module--snsIcon--b594a";